import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
  FormGroup,
  FormControlLabel,
  Checkbox,Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate ,useLocation} from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import axios from "../../../../lib/axios";
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const columns = [
  { id: 'RowNum', label: 'S.No.', minWidth: 170 },
  { id: 'RoomBedTypeName', label: 'Type', minWidth: 100 },
  { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const RoomBedType = () => {
  const [formData, setFormData] = useState({
    RoomBedTypeName: '',
    Remark: ''
  });

  // const permissions = useModulePermissions("BedType Master");

  const [error, setError] = useState({
    roomBedTypeName: false,
    remark: false
  });

  const navigate = useNavigate();

  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const location = useLocation();
  const [currentRoomBedTypeId, setCurrentRoomBedTypeId] = useState(null);
  const [mode, setMode] = useState('view');
  const [lastInsertedRoomBedTypeId, setLastInsertedRoomBedTypeId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [Status, setStatus] = useState("1");
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });
  
  const roomBedTypeNameRef = useRef(null);
  const remarkRef = useRef(null);

  useEffect(() => {
    if (location.state && location.state.RoomBedTypeId) {
      setCurrentRoomBedTypeId(location.state.RoomBedTypeId);
      fetchRoomBedTypeData(location.state.RoomBedTypeId);
      setMode('view');
    } else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);
 
  const fetchRoomBedTypeData = async (id, flag) => {
    try {
      const response = await axiosInstance.post(`RoomBedTypeMst/RetriveRoomBedTypeMst`, { 
        RoomBedTypeId: parseInt(id),
        Flag: flag 
      });
 
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const roomBedTypeData = response.data.Data[0];
        setFormData({
          RoomBedTypeName: roomBedTypeData.RoomBedTypeName, 
          Remark: roomBedTypeData.Remark
        });
        setStatus(roomBedTypeData.Status.toString() || "0");
        setIsFormDisabled(true);
        setCurrentRoomBedTypeId(roomBedTypeData.RoomBedTypeId); 
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);
      } else {
        toast.error('Failed to fetch roomBedType data');
      }
    } catch (error) {
      console.error('Error fetching roomBedType data:', error);
      toast.error('Error fetching roomBedType data. Please try again.');
    }
  };

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: ""
      };
  
      try {
        const res = await axios.post('RoomBedTypeMst/getAllRoomBedTypeMstDashBoard', { params });
  
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
  
    getRow();
  }, []);

  const handlePrevious = async () => {
    if (currentRoomBedTypeId && currentRoomBedTypeId > 1) {
      await fetchRoomBedTypeData(currentRoomBedTypeId, "P");
    }
  };

  const handleNext = async () => {
    if (currentRoomBedTypeId) {
      await fetchRoomBedTypeData(currentRoomBedTypeId, "N");
    }
  };

const handleInputChange = (event) => {
  const { name, value } = event.target;
  setFormData(prevState => ({
    ...prevState,
    [name]: value
  }));


  if (name === 'roomBedType') {
    setFormData(prevState => ({
      ...prevState,
      state: ''
    }));
  }

  if (name === 'roomBedType' && value !== '') {
    setTimeout(() => {
      remarkRef.current.focus();
    }, 100000);
  }
};

const handleKeyPress = (event) => {
  if (event.key === 'Enter') {
    remarkRef.current.focus();
  }
};

const handleSave = async () => {

  let hasError = false;

  if (!formData.RoomBedTypeName) {
    toast.error('RoomBedType Name is required');
    setError(prev => ({ ...prev, roomBedTypeName: true }));
    hasError = true;
  } else {
    setError(prev => ({ ...prev, roomBedTypeName: false }));
  }

  if (hasError) {
    return;
  }


  try {
    const payload = {
      RoomBedTypeName: formData.RoomBedTypeName,
      Remark: formData.Remark,
      Status: Status
    };

    let response;
    if (mode === 'edit') {
      payload.RoomBedTypeId = currentRoomBedTypeId;
      payload.UpdatedBy = parseInt(UserId, 10);
      response = await axiosInstance.patch(`RoomBedTypeMst/UpdateRoomBedTypeMst`, payload);
    } else {
      payload.CreatedBy = parseInt(UserId, 10);
      response = await axiosInstance.post(`RoomBedTypeMst/InsertRoomBedTypeMst`, payload);
    }

    if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
      toast.success(response.data.Message);
      if (mode === 'add') {
        setLastInsertedRoomBedTypeId(response.data.Data)
        await fetchRoomBedTypeData(response.data.Data);
        setMode('view');
        setIsFormDisabled(true);
        setCurrentRoomBedTypeId(response.data.Data);
      } else {
        setMode('view');
      }
      setIsFormDisabled(true);
    } else {
      toast.error(response.data.Message || 'Operation failed');
    }
  } catch (error) {
    console.error('Error saving/updating roomBedType:', error);
    toast.error('Error saving/updating roomBedType. Please try again.');
  }
};


  const handleEdit = () => {
    setMode('edit');
    setIsFormDisabled(false);
  };

  const handleAdd = () => {
    setMode('add');
    setIsFormDisabled(false);
    setFormData({
      RoomBedTypeName: '',
      Remark: ''
    });
    setCurrentRoomBedTypeId(null);

    setTimeout(() => {
      roomBedTypeNameRef.current.focus();
    }, 0);
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  const handleCancel = async () => {
    try {
      await fetchRoomBedTypeData(1, "L");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error occurred while cancelling. Please try again.');
    }
  };

  const resetForm = () => {
    setFormData({
      RoomBedTypeName: '',
      Remark: ''
    });
    setCurrentRoomBedTypeId(null);
    setMode('view');
  };

  const handleExit=()=>{
    navigate('/roomBedTypetable')
  }

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    try {
      await fetchRoomBedTypeData(currentRoomBedTypeId, "D");
      await fetchRoomBedTypeData(currentRoomBedTypeId, "N");
      setMode('view');
      setIsFormDisabled(true);

    } catch (error) {
      console.error('Error deleting roombed type:', error);
      toast.error('Error occurred while deleting. Please try again.');
    }
  };

  return (
    <>

      <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
   
      <ToastContainer />
        <Grid container spacing={2} className='form_grid'>
        <Grid item xs={12} className='form_title' 
          sx={{ 
                display: 'flex', alignItems: 'center', 
                justifyContent:'space-between', marginTop: '20px',
                flexDirection: { xs: 'column', sm: 'row', md: 'row' }  
              }}
            >
          <Grid
            sx={{
              display: 'flex',
              justifyContent: { xs: 'center', sm: 'flex-start' },
              marginBottom: { xs: '10px', sm: 0 }
            }}
          >
          <Button 
            variant="contained" 
            size="small" 
            className='three-d-button-previous'
            onClick={handlePrevious}
            sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
            disabled={mode !== 'view' || !currentRoomBedTypeId || currentRoomBedTypeId === 1}
          >
            <KeyboardArrowLeftIcon />
          </Button>
          
          <Button 
            variant="contained" 
            size="small" 
            // sx={{ margin:'0px 10px' }}  
            className='three-d-button-next'    
            onClick={handleNext}
            sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
            disabled={mode !== 'view' || !currentRoomBedTypeId}
          >
             <NavigateNextIcon />
          </Button>
          </Grid>
          
          <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              RoomBedType Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName={"BedType Master"}
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleConfirmDelete}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
        </Grid>
     
          <Grid item xs={12} className='form_field'>
            <Grid container spacing={2}>
             <Grid item xs={12} md={6} lg={5}>
              <TextField
               id="RoomBedTypeName"
               name="RoomBedTypeName"
               label={
                <span>
                  RoomBedType Name <span style={{ color: 'red' }}>*</span>
                </span>
               }
               variant="filled"
               fullWidth
               className="custom-textfield"
               value={formData.RoomBedTypeName}
               onChange={handleInputChange}
               disabled={isFormDisabled}
               error={error.roomBedTypeName}
               helperText={error.roomBedTypeName && ""}
               inputRef={roomBedTypeNameRef}
               onKeyDown={handleKeyPress}
              />
             </Grid>
              <Grid item xs={12} md={6} lg={5}>
                <TextField
                  id="Remark"
                  name="Remark"
                  label="Remark"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Remark}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.remark}
                  helperText={error.remark && ""}
                  inputRef={remarkRef}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={2}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isFormDisabled}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

        <Grid item xs={12} className="form_button">
          {mode === 'view' && (
            <>
              <Button variant="contained" sx={{ mr: 1 , background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                Submit
              </Button>
              <Button variant="contained" sx={{ mr: 1 , background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit} 
              disabled
              >
              Cancel
              </Button>
            </>
          )}
          {(mode === 'edit' || mode === 'add') && (
            <>
           
            <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                Submit
              </Button>
              <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                Cancel
              </Button>
             
            </>
          )}
        </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <ReportTable
          columns={columns}
          rows={rows}
          title="BedType Master"
          contentRef={contentRef}
          customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default RoomBedType